document.addEventListener('DOMContentLoaded', function() {
    function getDeliveryDate() {
        // Get today's date
        var today = new Date();
        
        // Add 2 days to today's date
        var deliveryDate = new Date(today);
        deliveryDate.setDate(today.getDate() + 2);
        
        // Check if the new date falls on a weekend
        if (deliveryDate.getDay() === 6) { // Saturday, set to Monday
            deliveryDate.setDate(deliveryDate.getDate() + 2);
        } else if (deliveryDate.getDay() === 0) { // Sunday, set to Monday
            deliveryDate.setDate(deliveryDate.getDate() + 1);
        }
        
        // More robust language detection
        var path = window.location.pathname;
        var locale = 'en-US'; // Default to English
        
        // Check for specific language patterns in URL
        if (path.startsWith('/fr/') || path === '/fr' || 
            path.includes('/fr?') || path.includes('?lang=fr')) {
            locale = 'fr-FR';
        }
        
        console.log('Final locale detection - Path:', path, 'Locale:', locale);
        
        // Format the date based on the locale
        var options = { weekday: 'short', month: 'short', day: 'numeric' };
        var formattedDate = deliveryDate.toLocaleDateString(locale, options);
        
        // Inject the formatted date into all elements with class 'delivery_date'
        var deliveryElements = document.querySelectorAll('.delivery_date');
        deliveryElements.forEach(function(element) {
            element.textContent = formattedDate;
        });
    }
    
    // Run multiple times to ensure it catches the element
    getDeliveryDate();
    setTimeout(getDeliveryDate, 100);
    setTimeout(getDeliveryDate, 1000);
});